




































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































// vue
import Vue, { PropOptions } from 'vue';
import NOC from '@/class/common/const';
import * as NOCArray from '@/personal/array';
import { fncChangeStringToJPFormatNonZero } from '@/class/common/moment';
import { strFuzzyMatch } from '@/class/common/util';
import Encoding from 'encoding-japanese';

// api
import API, { ApiResult } from '@/api/common';
import * as models from '@/class/models/views/setting/users';
import * as modelsDep from '@/class/models/views/department';
import * as modelsCsv from '@/class/models/views/setting/csv-import';
import * as modelsWorkManage from '@/class/models/views/setting/workmanage';
import { IAccount } from '@/class/models/views/account';

// validation
import * as validation from '@/personal/validation';

// util
import * as roleUtil from '@/class/common/util/role_util';

// components
import { IOption } from '@/components/util/NewSelectBox.vue';
import NewVariableInput, { INewVariableInput } from '@/components/util/NewVariableInput.vue';
import { INPUT_TYPE } from '@/components/util/input_type';

// import util from '@/components/util';
import SearchBox from '@/components/util/SearchBox.vue';
import SearchResult from '@/components/util/SearchResult.vue';
import SelectBox from '@/components/util/NewSelectBox.vue';
import CheckBoxList from '@/components/util/CheckBoxList.vue';
import SideBarBase from '@/components/util/SideBarBase.vue';

// parts
import RelationList, { IRelationData } from '@/parts/setting/users/RelationList.vue';
import UserSideModal, { IUserSideModalData } from '@/parts/setting/users/UserSideModal.vue';
import UserAddSpModal from '@/parts/setting/users/UserAddSpModal.vue';
import GroupSideModal from '@/parts/setting/users/GroupSideModal.vue';
import ModalDeleteConfirm from '@/components/util/ModalDeleteConfirm.vue';
import ModalExclusionDepartment from '@/components/util/ModalExclusionDepartment.vue';
import ModalFormDataCheck from '@/components/util/ModalFormDataCheck.vue';
import { IDepartmentInfo } from '@/class/models/views/dashboard';
import { isRoleShowAdminInLaborManagerSelectBox } from '@/util/role-util-frontend';

// datepicker
// import DatePicker from 'vuejs-datepicker';
// import {ja} from 'vuejs-datepicker/dist/locale';

// local const
const SIDE = {
  DEVICE: 'device',
  MODERATOR: 'moderator',
  GROUP: 'group',
};

export default Vue.extend({
  name: 'Users',
  // components: {
  //   RelationList, NewVariableInput, UserSideModal, UserAddSpModal, DatePicker, GroupSideModal,
  //   ModalDeleteConfirm, ...util,
  // },
  components: {
    SearchBox,
    RelationList,
    NewVariableInput,
    UserSideModal,
    UserAddSpModal,
    GroupSideModal,
    SelectBox,
    CheckBoxList,
    ModalDeleteConfirm,
    SearchResult,
    SideBarBase,
    ModalExclusionDepartment,
    ModalFormDataCheck,
  },
  props: {
    confirmDialog: Function,
    ownerFlag: Boolean,
    appData: Object,
  },
  data() {
    return {
      onload: false,
      accountData: {} as IAccount,
      usersList: [] as models.IUser[],
      devicesList: [] as models.IDevice[],
      moderatorsList: [] as models.IModerator[],
      groupList: [] as models.IGroup[],
      groupUsedList: [] as models.IGroupUsed[],
      historyList: [] as models.IInsertHistory[],
      selectUser: {} as models.IUser,
      selectUserDevicesList: [] as models.IDevice[],
      selectUserModeratorsList: [] as models.IModerator[],
      selectUserGroupList: [] as models.IGroup[],
      selectUserGroupUsedList: [] as models.IGroupUsed[],
      editUser: {} as models.IUser,
      editUserDevicesList: [] as models.IDevice[],
      editUserModeratorsList: [] as models.IModerator[],
      editUserGroupList: [] as models.IGroup[],
      editUserGroupUsedList: [] as models.IGroupUsed[],
      selectDepartment: {} as models.IDepartmentInfo,
      selectDepartmentModeratorsList: [] as models.IDepartmentModerator[],
      editDepartment: {} as models.IDepartmentInfo,
      editDepartmentModeratorsList: [] as models.IDepartmentModerator[],
      editWorkmanage: {} as modelsWorkManage.IWorkManage,
      editWorkmanages: [] as modelsWorkManage.IWorkManage[],
      departments: [] as models.IDepartmentInfo[],
      alldepartments: [] as models.IDepartmentInfo[],
      departmentModerators: [] as models.IDepartmentModerator[],
      workmanages: [] as modelsWorkManage.IWorkManage[],
      workManagementModerators: [] as modelsWorkManage.IWorkManageModerator[],
      csvConfirmData: {} as modelsCsv.VConfirmData,
      errorRows: [] as Array<{ [column: string]: string }>,
      sideTitle: '',
      sideModal: '',
      searchResultDepartments: '',
      selectedDepartmentID: -1,
      selectedUserID: -1,
      items: [
        { key: 'departmentText', name: '部署' },
        { key: 'jobText', name: '職種' },
        { key: 'group', name: 'グループ' },
        { key: 'workstyleText', name: '就業形態' },
        { key: 'flextime', name: 'フレックスタイム' }, // REMOLABO-395
        // {key: 'flextimeText', name: 'フレックスタイム' }, // REMOLABO-301
        { key: 'roleText', name: '権限' },
        { key: 'device', name: 'デバイス' },
        { key: 'laborManager', name: '労務管理者' },
        { key: 'business', name: '業務' },
        // {key: 'name', name: '氏名' },
        // {key: 'genderText', name: '性別' },
        // {key: 'kana', name: 'カナ' },
        // {key: 'mail', name: 'メールアドレス' },
        // {key: 'birthday', name: '生年月日' },
      ],
      items2: [
        { key: 'mail', name: 'メールアドレス' },
        { key: 'other', name: 'その他' },
      ],
      itemDepartment: [
        // {key: 'workstyleText', name: '就業形態'}, // 部署画面から「就業形態」「フレックスタイム」を削除
        // {key: 'flextime', name: 'フレックスタイム'}, // 部署画面から「就業形態」「フレックスタイム」を削除
        { key: 'parentDepartment', name: '親部署' },
        { key: 'laborManager', name: '管理者' },
        { key: 'business', name: '業務' },
      ],
      optionsRole: NOCArray.ROLE,
      optionsWorkstyle: [NOC.SELECT.FIRST],
      optionsDepartment: [NOC.SELECT.ALL_DEPARTMENTS] as models.ISelectOption[],
      searchSideList: '',
      inputedSearchDepartment: 0,
      inputedSearchName: '',
      inputedSearchNameCurrentDep: '',
      searchDepartment: 0,
      searchName: '',
      searchNameCurrentDep: '',
      importFile: null as any,
      importStatus: 'init',
      importError: '',
      mode: '',
      selectDepartmentUsers: [] as models.IDepartmentUsedUser[],
      editUsers: [] as models.IDepartmentUsedUser[],
      editItems: [
        {
          key: 'departmentID',
          required: true,
          name: '部署',
          type: INPUT_TYPE.SELECT,
          error: '',
          class: 'col-12',
          options: [NOC.SELECT.FIRST],
        },
        {
          key: 'jobID',
          name: '職種',
          type: INPUT_TYPE.SELECT,
          required: true,
          error: '',
          class: 'col-12',
          options: NOC.JOB.JOBArray,
        },
        {
          key: 'group',
          name: 'グループ',
          type: INPUT_TYPE.SEARCH,
          required: false,
          error: '',
          class: 'col-12',
          options: [],
        },
        {
          key: 'workstyleID',
          name: '就業形態',
          type: INPUT_TYPE.SELECT,
          required: true,
          error: '',
          class: 'col-12',
          options: [NOC.SELECT.FIRST],
        },
        // REMOLABO-395
        {
          key: 'flextime',
          name: 'フレックスタイム',
          type: INPUT_TYPE.CHECK,
          required: false,
          error: '',
          class: 'col-12 flextime',
        },
        // REMOLABO-301
        // {key: 'flextime', name: 'フレックスタイム', type: 'checkbox', required: false, error: '', class: 'col-6', options: [{text: 'あり', value: 1}] as models.ISelectOption[]},
        {
          key: 'role',
          name: '権限',
          type: INPUT_TYPE.SELECT,
          required: true,
          error: '',
          class: 'col-12',
          options: [NOC.SELECT.FIRST],
        },
        {
          key: 'mail',
          name: '招待メール宛先',
          placeholder: 'メールアドレス',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: 'col-12',
          checks: [validation.CHECK_TYPE.EMAIL],
          max: 40,
        },
        {
          key: 'device',
          name: 'デバイス',
          type: INPUT_TYPE.SEARCH,
          required: false,
          error: '',
          class: 'col-12',
          options: [],
        },
        {
          key: 'laborManager',
          name: '労務管理者',
          type: INPUT_TYPE.SEARCH,
          required: false,
          error: '',
          class: 'col-12',
          options: [],
        },
        {
          key: 'business',
          name: '業務',
          type: INPUT_TYPE.SEARCH,
          required: false,
          error: '',
          class: 'col-12',
          options: [],
        },
      ] as INewVariableInput[],
      editProfile: [
        {
          key: 'sei',
          name: '氏名',
          placeholder: '姓',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: '',
          max: 40,
        },
        {
          key: 'mei',
          name: '',
          placeholder: '名',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: '',
          max: 40,
        },
        {
          key: 'seiKana',
          name: 'フリガナ',
          placeholder: 'セイ',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: '',
          checks: [validation.CHECK_TYPE.KANA],
          max: 40,
        },
        {
          key: 'meiKana',
          name: '',
          placeholder: 'メイ',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: '',
          checks: [validation.CHECK_TYPE.KANA],
          max: 40,
        },
        {
          key: 'mail',
          name: 'メールアドレス',
          placeholder: 'メールアドレス',
          type: INPUT_TYPE.TEXT,
          required: false,
          error: '',
          class: 'col-12',
          checks: [validation.CHECK_TYPE.EMAIL],
          max: 40,
        },
        {
          key: 'gender',
          name: '性別',
          type: INPUT_TYPE.RADIO,
          required: false,
          class: 'col-12',
          options: NOCArray.GENDER,
        },
        {
          key: 'birthday',
          name: '生年月日',
          placeholder: '19901230',
          type: INPUT_TYPE.TEXT,
          required: false,
          error: '',
          class: 'col-12',
          checks: [validation.CHECK_TYPE.BIRTHDAY],
        },
      ] as INewVariableInput[],
      //   {key: 'sei', name: '氏名', type: INPUT_TYPE.TEXT, required: true, error: '', class: '', max: 40},
      //   {key: 'mei', name: '', type: INPUT_TYPE.TEXT, required: true, error: '', class: '', max: 40},
      //   {key: 'seiKana', name: 'フリガナ', type: INPUT_TYPE.TEXT, required: true, error: '', class: '', checks: [validation.CHECK_TYPE.KANA], max: 40},
      //   {key: 'meiKana', name: '', type: INPUT_TYPE.TEXT, required: true, error: '', class: '', checks: [validation.CHECK_TYPE.KANA], max: 40},
      //   {key: 'mail', name: 'メールアドレス', type: INPUT_TYPE.TEXT, required: false, class: 'col-12'},
      //   {key: 'genderText', name: '性別', type: INPUT_TYPE.RADIO, required: false, class: 'col-12'},
      //   {key: 'birthday', name: '生年月日', type: INPUT_TYPE.DATE, required: false, class: 'col-12' },
      // ] as INewVariableInput[],
      // inputItems: [
      //   {key: 'busyo', required: true, name: '部署', type: INPUT_TYPE.SELECT, error: '', class: 'col-12', max: 30},
      //   {key: 'jobID', name: '職種', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-12', options: NOC.JOB.JOBArray},
      //   {key: 'group', name: 'グループ', type: INPUT_TYPE.SEARCH, required: false, error: '', class: 'col-12', checks: [validation.CHECK_TYPE.KANA], max: 40},
      //   {key: 'workstyleID', name: '就業形態', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-12', options: [NOC.SELECT.FIRST]},
      //   {key: 'flex', name: 'フレックスタイム', type: INPUT_TYPE.CHECK, required: false, error: '', class: 'col-12' },
      //   {key: 'role', name: '権限', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-12', options: [NOC.SELECT.FIRST]},
      //   {key: 'device', name: 'デバイス', type: INPUT_TYPE.SEARCH, required: false, error: '', class: 'col-12'},
      //   {key: 'laborManager', name: '労務管理者', type: INPUT_TYPE.SEARCH, required: false, error: '', class: 'col-12' },
      //   {key: 'business', name: '業務', type: INPUT_TYPE.SEARCH, required: false, error: '', class: 'col-12' },
      // ] as INewVariableInput[],
      editDepItems: [
        {
          key: 'name',
          name: '部署名',
          placeholder: '部署名',
          type: INPUT_TYPE.TEXT,
          required: true,
          error: '',
          class: 'col-12',
          max: 20,
        },
        // {key: 'workstyleID', name: '就業形態', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-12', options: [NOC.SELECT.FIRST]},
        // {key: 'flextime', name: 'フレックスタイム', type: INPUT_TYPE.CHECK, required: false, error: '', class: 'col-12' },
        {
          key: 'parentID',
          name: '親部署',
          type: INPUT_TYPE.SELECT,
          required: false,
          error: '',
          class: 'col-12',
          options: [],
        },
        {
          key: 'laborManager',
          name: '労務管理者',
          type: INPUT_TYPE.SEARCH,
          required: false,
          error: '',
          class: 'col-12',
        },
        {
          key: 'business',
          name: '業務',
          type: INPUT_TYPE.SEARCH,
          required: false,
          error: '',
          class: 'col-12',
        },
      ] as INewVariableInput[],
      // editDepItems2: [
      //   {key: 'busyoName', required: true, name: '部署名', type: INPUT_TYPE.TEXT, error: '', class: 'col-12', max: 30},
      //   {key: 'workstyleID', name: '就業形態', type: INPUT_TYPE.SELECT, required: true, error: '', class: 'col-12', options: [NOC.SELECT.FIRST]},
      //   {key: 'flex', name: 'フレックスタイム', type: INPUT_TYPE.CHECK, required: false, error: '', class: 'col-12' },
      //   {key: 'parentDep', name: '親部署', type: INPUT_TYPE.SELECT, required: false, error: '', class: 'col-12', options: NOC.JOB.JOBArray},
      //   {key: 'laborManager', name: '労務管理者', type: INPUT_TYPE.SEARCH, required: false, error: '', class: 'col-12' },
      //   // {key: 'business', name: '業務', type: INPUT_TYPE.SEARCH, required: false, error: '', class: 'col-12' },
      // ] as INewVariableInput[],
      isRegistering: false,
      // DatePickerDate: 'yyyy年M月d日',
      // ja,
      addModalShowFlag: false,
      addSpModalShowFlag: false,
      fieldsItem: [
        { key: 'checked', label: '' },
        { key: 'departmentParent', sortable: true, label: '親部署' },
        { key: 'departmentChild', sortable: true, label: '子部署' },
        { key: 'user', sortable: true, label: '氏名' },
      ] as any[],
      fieldsItemCurrentDep: [
        { key: 'checked', label: '' },
        { key: 'user', sortable: true, label: '氏名' },
      ] as any[],
      userItem: [] as any[],
      userItemCurrentDep: [] as any[],
      userItemOtherDep: [] as any[],
      userItemSP: [] as any[],
      /*
      userItem: [
        { checked: true, departmentParent: '技術部', departmentChild: '営業部', user: '山田太郎' },
        { checked: true, departmentParent: '技術部', departmentChild: '営業部', user: '山田太郎' },
        { checked: true, departmentParent: '技術部', departmentChild: '営業部', user: '山田太郎' },
        { checked: true, departmentParent: '技術部', departmentChild: '営業部', user: '山田太郎' },
        { checked: true, departmentParent: '技術部', departmentChild: '営業部', user: '山田太郎' },
      ] as any[],
      */
      deleteDepartmentShowFlag: false,
      deleteUserShowFlag: false,
      isDefault: false, // SP初期表示時はdefault:true
      exclusionDepartmentShowFlag: false,
      formDataChangeFlgModal: false,
      compEditUser: {} as models.IUser,
      compEditUserDevicesList: [] as models.IDevice[],
      compEditUserModeratorsList: [] as models.IModerator[],
      compEditUserGroupList: [] as models.IGroup[],
      compEditUserGroupUsedList: [] as models.IGroupUsed[],
      compEditWorkmanages: [] as modelsWorkManage.IWorkManage[],
      compEditDepartment: {} as models.IDepartmentInfo,
      compEditDepartmentModeratorsList: [] as models.IDepartmentModerator[],
      compUserItemSP: [] as any[],
      compUserItemCurrentDep: [] as any[],
      otheritem: [] as any[],
      isCheckExcludeFlag: false,
      isCheckMoveFlag: false,
      isCheckAllExcludeFlag: false,
      isCheckAllMoveFlag: false,
      mailFlag: false,
      isProcessing: false, // 二重サブミット防止用
      laborManagerFilter: [] as string[],
      duplicateCount: 0,
    };
  },
  // directives: {
  //   DatePicker,
  // },
  watch: {
    'editUser.role'(to) {
      if (roleUtil.isRoleGeneral(to)) {
        this.editItems[6].required = false;
        this.editProfile[4].required = false;
      } else if (roleUtil.isRoleAdminOrManager(to)) {
        this.editItems[6].required = true;
        this.editProfile[4].required = true;
      }
    },
    'departments': {
      deep: true,
      handler(val, oldVal) {
        if (val !== oldVal) {
          const isClosedDeps = oldVal.filter((v: any) => v.isClosed === true);
          for (const dep of val) {
            for (const isClosedDep of isClosedDeps) {
              if (dep.departmentID === isClosedDep.departmentID) {
                this.$set(dep, 'isClosed', !dep.isClosed);
              }
            }
          }
        }
        localStorage.setItem(`department-${this.appData.mail}`, JSON.stringify(val));
      },
    },
    'mode'() {
      // modeが切り替わる度に実行中フラグをオフにする
      this.isProcessing = false;
    },
  },
  computed: {
    MODE_NORMAL(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL);
    },
    MODE_SELECT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.SELECT);
    },
    MODE_EDIT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT);
    },
    MODE_EDIT_BASE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_BASE);
    },
    MODE_EDIT_PROFILE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_PROFILE);
    },
    MODE_NEW(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW);
    },
    MODE_CHARGE(): boolean {
      return this.checkMode(NOC.SETTING.MODE.CHARGE);
    },
    MODE_NEW_NEXT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW_NEXT);
    },
    MODE_NEW_DEPARTMENT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW_DEPARTMENT);
    },
    MODE_NEW_DEPARTMENT_NEXT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NEW_DEPARTMENT_NEXT);
    },
    MODE_NORMAL_DEPARTMENT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.NORMAL_DEPARTMENT);
    },
    MODE_EDIT_BASE_DEPARTMENT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.EDIT_BASE_DEPARTMENT);
    },
    MODE_CSV_IMPORT(): boolean {
      return this.checkMode(NOC.SETTING.MODE.CSV_IMPORT);
    },
    DEPARTMENTS_PARENTS(): models.IDepartmentInfo[] {
      return this.departments.filter(v => !v.parentID);
    },
    // 計算値　ユーザ画面表示要に変換値
    DISP_SELECT_USER() {
      let dispSelectUser = {} as models.IUser;
      // console.log(this.selectUser.workstyleID);
      dispSelectUser = JSON.parse(JSON.stringify(this.selectUser));
      // 表示用にデータを変換
      dispSelectUser.roleText = NOCArray.getOptionsText(NOCArray.ROLE, dispSelectUser.role);
      dispSelectUser.genderText = NOCArray.getOptionsText(NOCArray.GENDER, this.selectUser.gender);
      if (this.selectUser.birthday) {
        dispSelectUser.birthday = fncChangeStringToJPFormatNonZero(this.selectUser.birthday);
      }
      if (this.selectUser.workstyleID) {
        dispSelectUser.workstyleText = NOCArray.getOptionsText(this.optionsWorkstyle, this.selectUser.workstyleID);
      }
      if (this.selectUser.departmentID) {
        const dep = this.departments.find(v => v.departmentID === this.selectUser.departmentID);
        dispSelectUser.departmentText = dep ? dep.name : '';
        // = NOCArray.getOptionsText(this.departments, this.selectUser.departmentID);
      }
      dispSelectUser.jobText = NOCArray.getOptionsText(NOC.JOB.JOBArray, this.selectUser.jobID);
      // dispSelectUser.flextimeText = this.selecUser.flextime ? 'あり' : 'なし';
      return dispSelectUser;
    },
    DISP_SELECT_DEPARTMENT() {
      let dispSelectDepartment = {} as models.IDepartmentInfo;
      dispSelectDepartment = JSON.parse(JSON.stringify(this.selectDepartment));
      // 表示用にデータを変換
      // if (this.selectDepartment.workstyleID) {
      //   dispSelectDepartment.workstyleText
      //     = NOCArray.getOptionsText(this.optionsWorkstyle, this.selectDepartment.workstyleID);
      // }
      if (this.selectDepartment.parentID) {
        const dep = this.departments.find(v => v.departmentID === this.selectDepartment.parentID);
        dispSelectDepartment.parentDepartment = dep ? dep.name : '';
      }
      return dispSelectDepartment;
    },
    // 計算値　関連デバイス表示配列
    DISP_DEVICES_LIST(): IRelationData[] {
      const list =
        this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)
          ? this.editUserDevicesList
          : this.selectUserDevicesList;
      return list.map(v => ({ id: v.deviceID, contents: [v.account, v.name] }));
    },
    EDIT_DEVICES_LIST(): models.ISelectOption[] {
      return this.editUserDevicesList.map(v => ({
        value: v.deviceID,
        text: `${v.name} (${v.account})`,
      }));
    },
    // 計算値　関連管理者画面表示配列
    DISP_MODERATORS_LIST(): IRelationData[] {
      const list =
        this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)
          ? this.editUserModeratorsList
          : this.selectUserModeratorsList;
      return list.map(v => {
        const moderator = this.getModeratorUser(v.manageID);
        return { id: v.manageID, contents: [moderator.name, moderator.mail] };
      });
    },
    EDIT_MODERATORS_LIST(): models.ISelectOption[] {
      return this.editUserModeratorsList.map(v => {
        const moderator = this.getModeratorUser(v.manageID);
        return {
          value: v.manageID,
          text: `${moderator.name} (${moderator.mail})`,
        };
      });
    },
    DISP_DEPARTMENT_MODERATORS_LIST(): IRelationData[] {
      const list =
        this.checkMode(NOC.SETTING.MODE.EDIT_BASE_DEPARTMENT) || this.checkMode(NOC.SETTING.MODE.NEW_DEPARTMENT)
          ? this.editDepartmentModeratorsList
          : this.selectDepartmentModeratorsList;
      return list.map(v => {
        const moderator = this.getModeratorUser(v.manageID);
        return { id: v.manageID, contents: [moderator.name, moderator.mail] };
      });
    },
    EDIT_DEPARTMENT_MODERATORS_LIST(): models.ISelectOption[] {
      return this.editDepartmentModeratorsList.map(v => {
        const moderator = this.getModeratorUser(v.manageID);
        return {
          value: v.manageID,
          text: `${moderator.name} (${moderator.mail})`,
        };
      });
    },
    EDIT_WORK_MG_LIST(): models.ISelectOption[] {
      return this.editWorkmanages.map(v => {
        const moderator = this.getWorkManage(v.workmanageID);
        return { value: v.workmanageID, text: moderator.name };
      });
    },
    OPTION_MODERATORS_LIST(): models.ISelectOption[] {
      return this.usersList
        .filter(v => roleUtil.isRoleAdminOrManager(v.role))
        .map(v => ({ text: `${v.name} (${v.mail})`, value: v.userID }));
    },
    OPTION_DEPARTMENT_LIST(): models.ISelectOption[] {
      return this.departments.map(v => ({
        value: v.departmentID,
        text: v.name,
      }));
    },
    OPTION_WORK_MG_LIST(): models.ISelectOption[] {
      return this.workmanages.map(v => ({
        value: v.workmanageID,
        text: v.name,
      }));
    },
    /**
     * 設定済みの業務を表示する
     */
    DISP_WORK_MG_LIST(): IRelationData[] {
      const list =
        this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)
          ? this.editWorkmanages
          : this.workmanages;
      if (this.selectedUserID !== -1) {
        // 現在選択しているユーザーに紐づいている業務のID一覧を取り出す
        const usedIdList = this.workManagementModerators
          .filter(v => v.userId === this.selectUser.userID)
          .map(v => v.workmanageID);
        return list
          .filter(v => usedIdList.includes(v.workmanageID))
          .map(v => ({ id: v.workmanageID, contents: [v.name] }));
      } else {
        // 現在選択している部署に紐づいている業務のID一覧を取り出す
        return list
          .filter(v => this.selectDepartment.workmanageId.includes(v.workmanageID))
          .map(v => ({ id: v.workmanageID, contents: [v.name] }));
      }
    },
    // methodに移動
    // OPTION_PARENT_DEPARTMENT_LIST(): models.ISelectOption[] {
    //   return [NOC.SELECT.NOSELECT_LONG].concat(
    //     this.departments.filter((v) => !v.parentID && v.departmentID).map((v) => ({value: v.departmentID, text: v.name})));
    // },
    // 計算値　関連管理者画面表示配列
    DISP_GROUPS_LIST(): IRelationData[] {
      const grouplist =
        this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)
          ? this.editUserGroupList
          : this.selectUserGroupList;
      const groupUsedlist =
        this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)
          ? this.editUserGroupUsedList
          : this.selectUserGroupUsedList;
      return groupUsedlist
        .filter(gu => gu.userID === this.selectUser.userID)
        .map(gu => {
          const targetGroup = grouplist.filter(g => gu.groupID === g.groupID);
          return {
            id: gu.groupID,
            contents: [targetGroup.length > 0 ? targetGroup[0].name : ''],
          };
        });
    },
    EDIT_GROUP_LIST(): models.ISelectOption[] {
      return this.editUserGroupUsedList
        .filter(v => v.userID === this.editUser.userID)
        .map(v => {
          const group = this.editUserGroupList.find(v2 => v.groupID === v2.groupID);
          return { value: v.groupID, text: group ? group.name : '' };
        });
    },
    OPTION_GROUP_LIST(): models.ISelectOption[] {
      return this.groupList.map(v => ({ text: v.name, value: v.groupID }));
    },
    // 未紐づけと選択ユーザーのデバイス
    OPTION_DEVICE_LIST(): models.ISelectOption[] {
      return this.devicesList
        .filter((v: models.IDevice) => v.userID === 0 || v.userID === this.editUser.userID)
        .map((v: models.IDevice) => ({
          text: `${v.name} (${v.account})`,
          value: v.deviceID,
        }));
    },
    // 計算値　サイドモーダル表示項目配列
    SIDE_MODAL_LIST(): IUserSideModalData[] {
      // todo
      let returnArray;
      if (this.sideModal === SIDE.DEVICE) {
        // 比較用の配列を作成
        const check = this.editUserDevicesList.map((v: models.IDevice) => v.deviceID);
        // 未選択デバイスかつ編集中以外の項目を表示
        returnArray = this.devicesList
          .filter((v: models.IDevice) => v.userID === 0 && !check.includes(v.deviceID))
          .map((v: models.IDevice) => ({
            texts: [v.name, v.account],
            value: v.deviceID,
          }));
      } else {
        // 比較用の配列を作成
        const check = this.editUserModeratorsList.map((v: models.IModerator) => v.manageID);
        // 一般権限以外かつ未選択の項目を表示

        returnArray = this.usersList
          .filter((v: models.IUser) => !roleUtil.isRoleGeneral(v.role) && !check.includes(v.userID))
          .map((v: models.IUser) => ({
            texts: [v.name, v.mail],
            value: v.userID,
          }));
      }
      return returnArray;
    },
    SIDE_LIST(): any[] {
      let returnArray = this.usersList;
      if (this.searchSideList.length > 0) {
        returnArray = this.usersList.filter((v: models.IUser) => v.name.indexOf(this.searchSideList) >= 0);
      }
      return returnArray;
    },
    SELECTED_ID(): string {
      return this.selectedDepartmentID > -1 ? `p${this.selectedDepartmentID}` : `c${this.selectedUserID}`;
    },
    getOptionsText() {
      return NOCArray.getOptionsText;
    },
    CSV_ID() {
      return NOC.CSV;
    },
    isCheckExclude(): boolean {
      const ExcludeValues = [];
      let count = 0;
      for (const i of this.userItemCurrentDep) {
        count += 1;
        if (i.checked) {
          ExcludeValues.push(i.checked);
        }
      }

      if (ExcludeValues.length === 0) {
        this.isCheckExcludeFlag = false;
        this.isCheckAllExcludeFlag = false;
      } else if (ExcludeValues.length === count) {
        this.isCheckExcludeFlag = true;
        this.isCheckAllExcludeFlag = true;
      } else {
        this.isCheckExcludeFlag = true;
        this.isCheckAllExcludeFlag = false;
      }

      return this.isCheckExcludeFlag || this.isCheckAllExcludeFlag;
    },
    isCheckMove(): boolean {
      const MoveValues = [];
      let count = 0;
      for (const i of this.userItemOtherDep) {
        count += 1;
        if (i.checked) {
          MoveValues.push(i.checked);
        }
      }

      if (MoveValues.length === 0) {
        this.isCheckMoveFlag = false;
        this.isCheckAllMoveFlag = false;
      } else if (MoveValues.length === count) {
        this.isCheckMoveFlag = true;
        this.isCheckAllMoveFlag = true;
      } else {
        this.isCheckMoveFlag = true;
        this.isCheckAllMoveFlag = false;
      }

      return this.isCheckMoveFlag || this.isCheckAllMoveFlag;
    },
  },
  // 画面表示時処理
  async mounted() {
    this.mode = NOC.SETTING.MODE.CHARGE;
    this.$emit('pushPath', this.$route.path);
    const query = this.$route.query;
    const api = new API();
    const res = await api.get<models.VUsers>('users');
    if (res.result) {
      this.groupList = res.data.groups;
      this.groupUsedList = res.data.groupUseds;
      this.usersList = res.data.users;
      this.departments = this.departments.concat(res.data.departments);
      this.alldepartments = this.departments.concat(res.data.departments);
      this.departmentModerators = res.data.departmentModerators;
      this.workmanages = res.data.workmanages;
      this.workManagementModerators = res.data.workmanageModerators;
      this.mode = NOC.SETTING.MODE.NORMAL;
      this.groupList = res.data.groups;
      this.groupUsedList = res.data.groupUseds;
      this.selectUser = this.usersList[0];
      if (this.$props.ownerFlag) {
        this.devicesList = res.data.devices;
        this.moderatorsList = res.data.moderators;
        if (res.data.optionsWorkstyle.length > 0) {
          this.optionsWorkstyle = res.data.optionsWorkstyle;
          this.editItems[3].options = this.optionsWorkstyle;
          // this.editDepItems[1].options = this.optionsWorkstyle;
        }
        // 再度データ再取得を非同期でかける
        this.reGet();
      }

      // メインエリア初期表示
      if (query && (query.user_id || query.department_id)) {
        // ダッシュボードから遷移してきた場合
        if (query.user_id) {
          // ユーザーを選択
          const userID = Number(query.user_id);
          const user = this.usersList.find(v => v.userID === userID);
          if (user) {
            this.onClickUser(user);
            this.selectedUserID = userID;
            this.selectedDepartmentID = -1;
          }
        } else if (query.department_id) {
          // 部署を選択
          const depID = Number(query.department_id);
          const department = this.departments.find(v => v.departmentID === depID);
          if (department) {
            this.onClickDepartment(department);
            this.selectedUserID = -1;
            this.selectedDepartmentID = depID;
          }
        }
        // URLをクエリなしに書き換え
        this.$router.replace('/setting/users');
      } else {
        if (query && query.md) {
          // ハンバーガーメニューから遷移してきた場合、サイドバー(SP)を初期表示する
          this.isDefault = true;
          // URLをクエリなしに書き換え
          this.$router.replace('/setting/users');
        }
        // メニューから遷移してきた場合、初期表示のリストの先頭ユーザーを表示
        this.onClickUser(res.data.users[0]);
        this.selectedUserID = this.selectUser.userID;
        this.selectedDepartmentID = -1;
      }

      // 「アカウント管理者」を労務管理選択ボックスに表示しないか。
      if (false === isRoleShowAdminInLaborManagerSelectBox(this.appData.role)) {
        // アカウント管理者を選択肢に出さないためのフィルタリングを設定。
        this.laborManagerFilter = [`${this.appData.username} (${this.appData.mail})`];
      }
    } else {
      this.$emit('change', NOC.APP.MODE.LOGIN);
    }

    const localDeps = localStorage.getItem(`department-${this.appData.mail}`);
    if (localDeps) {
      const parsedeps = JSON.parse(localDeps);
      const isClosedDeps = parsedeps.filter((v: any) => v.isClosed === true);
      const addIsClosedDeps = this.departments;
      for (const dep of addIsClosedDeps) {
        for (const isClosedDep of isClosedDeps) {
          if (dep.departmentID === isClosedDep.departmentID) {
            this.$set(dep, 'isClosed', !dep.isClosed);
          }
        }
      }
      this.departments = addIsClosedDeps;
    }

    // 読み込み完了
    this.onload = true;
  },
  methods: {
    isRoleInvited(role: number): boolean {
      return roleUtil.isRoleInvited(role);
    },
    // computedから移動
    OPTION_PARENT_DEPARTMENT_LIST(): models.ISelectOption[] {
      return [NOC.SELECT.NOSELECT_LONG].concat(
        this.departments.filter(v => !v.parentID && v.departmentID).map(v => ({ value: v.departmentID, text: v.name })),
      );
    },
    getParentID(v: any) {
      return v.departmentID;
    },
    getParentText(v: any) {
      return v.name;
    },
    getChildID(v: any) {
      return v.userID;
    },
    getChildText(v: any) {
      return `${v.sei}${v.mei}`;
    },
    getChildTextSearch(v: any) {
      return `${v.sei}${v.mei}${v.seiKana}${v.meiKana}`;
    },
    async reGet() {
      const api = new API();
      const res = await api.get<models.VUsers>('users/back');

      if (res.data) {
        this.usersList = res.data.users;
        if (res.data.optionsWorkstyle.length > 0) {
          this.optionsWorkstyle = res.data.optionsWorkstyle;
          this.editItems[3].options = this.optionsWorkstyle;
          //   this.editDepItems[1].options = this.optionsWorkstyle;
        }
        this.devicesList = res.data.devices;
        this.moderatorsList = res.data.moderators;
      }
    },
    async onClickResend() {
      if (!(await this.confirmDialog('招待メールを再送しますか？'))) {
        return;
      }
      const api = new API();
      const res = await api.get<{}>('users/resend', {
        targetID: this.selectUser.userID,
      });
      if (res.result) {
        this.$emit('info', '再送しました。');
      } else {
        this.$emit('info', '再送できませんでした。');
      }
    },
    // モード判定
    checkMode(mode: string) {
      return this.mode === mode;
    },
    // サイドバー項目選択処理（ユーザー）
    async onClickUser(user: models.IUser) {
      // if (this.checkMode(NOC.SETTING.MODE.EDIT) || this.checkMode(NOC.SETTING.MODE.NEW)) {
      //   return;
      // }
      this.onClickCancel(); // リセット
      this.selectedDepartmentID = -1;
      this.selectedUserID = user.userID;
      this.selectUser = user;
      this.selectUserDevicesList = this.devicesList.filter((v: models.IDevice) => v.userID === user.userID);
      this.selectUserModeratorsList = this.moderatorsList.filter((v: models.IModerator) => v.generalID === user.userID);
      this.selectUserGroupList = this.groupList;
      this.selectUserGroupUsedList = this.groupUsedList;
      this.mode = NOC.SETTING.MODE.SELECT;
      window.scrollTo(0, 0);
    },
    // サイドバー項目選択処理（部署）
    onClickDepartment(department: models.IDepartmentInfo) {
      this.selectedDepartmentID = department.departmentID;
      this.selectedUserID = -1;
      this.selectDepartment = department;
      // 部署の労務管理者
      this.selectDepartmentModeratorsList = this.departmentModerators.filter(
        v => v.departmentID === department.departmentID,
      );
      // 対象ユーザー一覧
      const parentDepartment = this.departments.find(v => v.departmentID === department.parentID);
      this.selectDepartmentUsers = this.usersList
        .filter(v => v.departmentID === department.departmentID)
        .map(
          v =>
            ({
              userID: v.userID,
              sei: v.sei,
              mei: v.mei,
              mail: v.mail,
              departmentID: v.departmentID,
              departmentChildID: 0,
              departmentChild: department.name,
              departmentParentID: 0,
              departmentParent: parentDepartment ? parentDepartment.name : '',
              checked: false,
            } as models.IDepartmentUsedUser),
        );
      this.normalDepartment();
    },
    // サイドバークラス項目処理
    classSideListActiveData(user: models.IUser) {
      return {
        active: this.selectUser.userID === user.userID,
      };
    },
    // 基本情報の編集ボタン押下時処理
    onClickEditBase() {
      this.editUser = JSON.parse(JSON.stringify(this.selectUser));
      this.editUserDevicesList = JSON.parse(JSON.stringify(this.selectUserDevicesList));
      this.editUserModeratorsList = JSON.parse(JSON.stringify(this.selectUserModeratorsList));
      this.editItems[0].options = this.OPTION_DEPARTMENT_LIST;
      this.editItems[2].options = this.OPTION_GROUP_LIST;
      this.editItems[5].options = this.setOptionsRole(this.selectUser.role);
      this.editItems[7].options = this.OPTION_DEVICE_LIST;
      this.editItems[8].options = this.OPTION_MODERATORS_LIST;
      this.editItems[9].options = this.OPTION_WORK_MG_LIST;
      this.editUserGroupList = this.groupList;
      this.editUserGroupUsedList = this.groupUsedList;
      // 設定済みの業務を選択した状態にする
      this.editWorkmanages = JSON.parse(
        JSON.stringify(this.workManagementModerators.filter(v => this.selectedUserID === v.userId)),
      );
      // this.editItems[4].disabled = true;
      // roleに応じての処理
      if (roleUtil.isRoleAdmin(this.editUser.role)) {
        this.editItems[5].disabled = true;
        this.editItems[6].disabled = true;
      }
      this.clearFilter();
      this.mode = NOC.SETTING.MODE.EDIT_BASE;

      // 編集ボタン押下時のデータを退避
      this.compEditUser = JSON.parse(JSON.stringify(this.selectUser));
      this.compEditUserGroupList = JSON.parse(JSON.stringify(this.groupList));
      this.compEditUserGroupUsedList = JSON.parse(JSON.stringify(this.groupUsedList));
      this.compEditUserDevicesList = JSON.parse(JSON.stringify(this.selectUserDevicesList));
      this.compEditUserModeratorsList = JSON.parse(JSON.stringify(this.selectUserModeratorsList));
      this.compEditWorkmanages = JSON.parse(JSON.stringify(this.editWorkmanages));

      window.scrollTo(0, 0);
    },
    // プロフィールの編集ボタン押下時処理
    onClickEditProfile() {
      this.editUser = JSON.parse(JSON.stringify(this.selectUser));
      this.editProfile[4].required = !roleUtil.isRoleGeneral(this.editUser.role);
      this.mode = NOC.SETTING.MODE.EDIT_PROFILE;
      this.mailFlag = false;
      if (roleUtil.isRoleAdmin(this.editUser.role)) {
        this.mailFlag = true;
      }

      // 編集ボタン押下時のデータを退避
      this.compEditUser = JSON.parse(JSON.stringify(this.selectUser));
      window.scrollTo(0, 0);
    },
    // キャンセルボタン押下時処理
    onClickCancel() {
      this.sideModal = '';
      window.scrollTo(0, 0);
      this.editProfile.forEach(profile => (profile.error = ''));
      // this.mode = NOC.SETTING.MODE.NORMAL;
      // this.selectUser = {} as models.IUser;
      // this.selectUserModeratorsList = [];
      // this.selectUserDevicesList = [];
      this.editUser = {} as models.IUser;
      this.editDepartment = {} as models.IDepartmentInfo;
      this.editUserDevicesList = [];
      this.editUserModeratorsList = [];
      this.editItems[5].disabled = false;
      this.editItems[6].disabled = false;
      this.clearFilter();
    },
    // ユーザーの基本情報の登録ボタン押下時処理
    async onClickRegistBase() {
      // validation
      if (validation.checkValues(this.editUser, this.editItems)) {
        return false;
      }

      // 担当がいる状態で労務管理者の権限を一般ユーザに変更することはできない
      const isRoleChanged = this.selectUser.role !== this.editUser.role;
      if (
        isRoleChanged &&
        roleUtil.isRoleManager(this.selectUser.role) &&
        (this.moderatorsList.some(info => info.manageID === this.selectUser.userID) ||
          this.departmentModerators.some(info => info.manageID === this.selectUser.userID))
      ) {
        this.$emit(
          'info',
          '一般ユーザーに変更する場合は、この労務管理者の管理対象にしている部署とユーザーをすべて解除してください。',
        );
        return;
      }
      // 既存のcoginitoアカウントが削除される場合は警告する
      if (
        isRoleChanged ||
        (this.selectUser.mail !== this.editUser.mail &&
          roleUtil.isRoleInvited(this.editUser.role) &&
          this.selectUser.mail.length > 0)
      ) {
        if (!(await this.confirmDialog('対象ユーザーのログイン情報が初期化されます。\nよろしいでしょうか？'))) {
          return;
        }
      }

      this.isRegistering = true;

      // 登録数を調整
      if (this.MODE_NEW && this.usersList.length >= 200) {
        if (!this.accountData.contract) {
          // accountDataを取得していなければ通信
          const apiAccount = new API();
          const resAccount = await apiAccount.get<IAccount>('account');
          if (resAccount.result) {
            this.accountData = resAccount.data;
          }
        }
        // TRIALの申し込みなしは上限200人、
        // TRIALの申込済みとREGIST, DELAYの場合上限なし
        if (
          this.accountData.contract &&
          this.accountData.contract === NOC.CONTRACT.TRIAL &&
          this.accountData.quit === 1
        ) {
          // this.$emit('info', '登録できません。お問い合わせからご連絡をお願いいたします。');
          this.$emit(
            'info',
            'お試しプランでは200名まで登録可能です。200名を超えて登録するには有料プランへのご登録をお願いいたします。',
          );
          this.isRegistering = false;
          return;
        }
      }

      // 値を設定
      const requestData: models.VEditUser = {
        user: this.editUser,
        deviceIDs: this.editUserDevicesList.map((v: models.IDevice) => v.deviceID),
        manageUserIDs: this.editUserModeratorsList.map((v: models.IModerator) => v.manageID),
        // groupIDs: JSON.stringify(this.groupList) === JSON.stringify(this.editUserGroupList) ? [] : this.editUserGroupList,
        // groupUsedIDs: this.editUserGroupUsedList,
        groupIDs: this.editUserGroupUsedList.filter(v => v.userID === this.editUser.userID).map(v => v.groupID),
        workmanageIDs: this.editWorkmanages.map(work => work.workmanageID),
      };
      // 登録実行
      const api = new API();
      const res = await api.put<models.VEditUser, models.VUsers>('users/edit/info', requestData);
      this.processAfterUpdate(res);
      this.backToSelectedUser(res);
    },
    // ユーザーのプロフィールの登録ボタン押下時処理
    async onClickRegistProfile() {
      // validation
      if (validation.checkValues(this.editUser, this.editProfile)) {
        return false;
      }

      // 既存のcoginitoアカウントが削除される場合は警告する
      // @todo: iwasaki REMOLABO-1138 プロフィールのメールアドレスはのちに削除予定のため暫定的な対処
      if (
        this.selectUser.mail !== this.editUser.mail &&
        roleUtil.isRoleInvited(this.editUser.role) &&
        this.selectUser.mail.length > 0
      ) {
        if (!(await this.confirmDialog('対象ユーザーのログイン情報が初期化されます。\nよろしいでしょうか？'))) {
          return;
        }
      }

      // 値を設定
      const requestData: models.VEditUserProfile = { user: this.editUser };
      // 登録実行
      const api = new API();
      const res = await api.put<models.VEditUserProfile, models.VUsers>('users/edit/profile', requestData);
      this.processAfterUpdate(res);
      this.backToSelectedUser(res);
    },
    // ユーザー新規追加の決定ボタン押下時処理
    async onClickRegistNewUser() {
      window.scrollTo(0, 0);
      // validation
      if (validation.checkValues(this.editUser, this.editItems)) {
        return false;
      }

      // 値を設定
      const requestData: models.VEditUser = {
        user: this.editUser,
        deviceIDs: this.editUserDevicesList.map((v: models.IDevice) => v.deviceID),
        manageUserIDs: this.editUserModeratorsList.map((v: models.IModerator) => v.manageID),
        groupIDs: this.editUserGroupUsedList.filter(v => !v.userID).map(v => v.groupID),
        workmanageIDs: this.editWorkmanages.map(v => v.workmanageID),
      };
      // 登録実行
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<models.VEditUser, models.VUsers>('users/new', requestData);
      this.processAfterUpdate(res);
      // this.mode = NOC.SETTING.MODE.NORMAL;
      this.newSelectedUser(res);
      this.isProcessing = false;
    },
    // 部署新規追加の決定ボタン押下時処理
    async onClickRegistNewDepartment() {
      window.scrollTo(0, 0);
      // validation
      if (validation.checkValues(this.editDepartment, this.editDepItems)) {
        return false;
      }
      // 値を設定
      const requestData: modelsDep.VDepartment = {
        department: this.editDepartment,
        manageUserIDs: this.editDepartmentModeratorsList.map(v => v.manageID),
        userIDs: this.editUsers.filter(v => v.checked).map(v => v.userID),
        workmanageIDs: this.editWorkmanages.map(work => work.workmanageID),
      };
      // 登録実行
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<modelsDep.VDepartment, models.VUsers>('users/department/new', requestData);
      this.processAfterUpdate(res);
      // this.mode = NOC.SETTING.MODE.NORMAL;
      this.newSelectedDepartment(res);
      this.isProcessing = false;
    },
    // 部署の基本情報の登録ボタン押下時処理
    async onClickRegistBaseDepartment() {
      // validation
      if (validation.checkValues(this.editDepartment, this.editDepItems)) {
        return false;
      }
      // 値を設定
      const requestData: modelsDep.VEditDepartmentInfo = {
        departmentInfo: this.editDepartment,
        manageUserIDs: this.editDepartmentModeratorsList.map(v => v.manageID),
        workmanageIDs: this.editWorkmanages.map(work => work.workmanageID),
      };
      // 登録実行
      const api = new API();
      const res = await api.put<modelsDep.VEditDepartmentInfo, models.VUsers>(
        'users/department/edit/info',
        requestData,
      );
      this.processAfterUpdate(res);
      this.backToSelectedDepartment(res);
    },
    // 部署の対象ユーザーの登録ボタン押下時処理
    async onClickRegistDepartmentUsers() {
      // 値を設定
      const requestData: modelsDep.VEditDepartmentUsed = {
        // department: this.editDepartment,
        users: this.editUsers
          .filter(v => v.departmentID)
          .map(v => ({ userID: v.userID, departmentID: v.departmentID })),
      };
      // 登録実行
      const api = new API();
      const res = await api.put<modelsDep.VEditDepartmentUsed, models.VUsers>(
        'users/department/edit/used',
        requestData,
      );
      this.processAfterUpdate(res);
      this.backToSelectedDepartment(res);
    },
    // 更新後の後処理
    processAfterUpdate(res: ApiResult<models.VUsers>, errMsg?: string, errFunc?: () => void) {
      if (res.result) {
        this.departmentModerators = res.data.departmentModerators;
        this.departments = res.data.departments;
        this.usersList = res.data.users;
        if (this.$props.ownerFlag) {
          this.devicesList = res.data.devices;
          this.moderatorsList = res.data.moderators;
        }
        this.workManagementModerators = res.data.workmanageModerators;
        this.groupList = res.data.groups;
        this.groupUsedList = res.data.groupUseds;
        this.historyList = res.data.insertHistories;
        this.onClickCancel();
      } else {
        if (errFunc) {
          errFunc();
        } else {
          const msg = errMsg || '登録できませんでした。';
          this.$emit('info', msg);
        }
      }
      this.isRegistering = false;
    },
    // 更新前に選択していたユーザーに戻る処理
    backToSelectedUser(res: ApiResult<models.VUsers>) {
      if (res.result) {
        const user = this.usersList.find(v => v.userID === this.selectedUserID);
        if (user) {
          this.onClickUser(user);
          this.mode = NOC.SETTING.MODE.SELECT;
        } else {
          this.mode = NOC.SETTING.MODE.NORMAL;
        }
      }
    },
    // 新規登録したユーザーを表示処理
    newSelectedUser(res: ApiResult<models.VUsers>) {
      if (res.result) {
        const user = this.usersList.find(v => v.userID === res.data.users[res.data.users.length - 1].userID);
        if (user) {
          this.onClickUser(user);
          this.mode = NOC.SETTING.MODE.SELECT;
        } else {
          this.mode = NOC.SETTING.MODE.NORMAL;
        }
      }
    },
    // 更新前に選択していた部署に戻る処理
    backToSelectedDepartment(res: ApiResult<models.VUsers>) {
      // this.selectedDepartmentID
      if (res.result) {
        const dep = this.departments.find(v => v.departmentID === this.selectedDepartmentID);
        if (dep) {
          this.onClickDepartment(dep);
          this.mode = NOC.SETTING.MODE.NORMAL_DEPARTMENT;
        } else {
          this.mode = NOC.SETTING.MODE.NORMAL;
        }
      }
    },
    // 新規登録した部署を表示処理
    newSelectedDepartment(res: ApiResult<models.VUsers>) {
      if (res.result) {
        // 部署リストのソート用の関数を宣言
        const sortFunc = (a: models.IDepartmentInfo, b: models.IDepartmentInfo) => {
          if (a.departmentID > b.departmentID) {
            return 1;
          } else {
            return -1;
          }
        };

        // オブジェクト複製用の関数作成
        const createCloneFunc = (a: models.IDepartmentInfo): models.IDepartmentInfo => {
          let clone: models.IDepartmentInfo = {} as models.IDepartmentInfo;
          return (clone = { ...a });
        };

        // responseの部署情報のリストを複製
        const cloneDepartMents = res.data.departments.map(v => createCloneFunc(v));

        // 部署リストをIDの昇順でソートして、部署IDが一番大きいものを取得する
        const dep = this.departments.find(
          v => v.departmentID === cloneDepartMents.sort(sortFunc)[res.data.departments.length - 1].departmentID,
        );
        if (dep) {
          this.onClickDepartment(dep);
          this.mode = NOC.SETTING.MODE.NORMAL_DEPARTMENT;
        } else {
          this.mode = NOC.SETTING.MODE.NORMAL;
        }
      }
    },
    // 登録ボタン押下時処理
    async onClickRegist() {
      // 登録数を調整 todoいずれは
      if (this.usersList.length >= 200) {
        this.$emit('info', '登録できません。お問い合わせからご連絡をお願いいたします。');
        return;
      }

      // const api = new API();
      // let res;

      // if (this.$props.ownerFlag) {
      //   if (this.checkMode(NOC.SETTING.MODE.NEW)) {
      //     // 新規登録
      //     res = await api.post<models.VEditUser, models.VUsers>('users/new', requestData);
      //   } else {
      //     // 更新
      //     res = await api.put<models.VEditUser, models.VUsers>('users/edit', requestData);
      //   }
      // } else {
      //   res = await api.post<models.VEditUser, models.VUsers>('users/group/edit', requestData);
      // }
    },
    // ユーザー削除処理
    async onClickDeleteUser() {
      // console.log(this.selectUser.userID);
      // if (await this.confirmDialog('選択中のユーザーを削除します、よろしいでしょうか？')) {
      // デバイスと管理者に関連付けがある場合削除しない
      if (this.selectUserDevicesList.length > 0) {
        this.$emit('info', 'デバイス上に関連があるため削除できません。');
        return;
      }

      if (this.selectUserModeratorsList.length > 0) {
        this.$emit('info', '管理者情報に関連があるため削除できません。');
        return;
      }
      // todo:ユーザが他と関連付けがあることによる削除不可は別途対応
      const api = new API();
      const res = await api.delete<models.VUsers>('users/delete', {
        deleteID: this.selectUser.userID,
      });
      this.processAfterUpdate(res, '削除できませんでした。');
      this.isDefault = true;
      if (this.usersList.length > 0) {
        this.selectedUserID = this.usersList[0].userID;
      }
      this.backToSelectedUser(res);
      // if (res.result) {
      //   this.usersList = res.data.users;
      //   this.devicesList = res.data.devices;
      //   this.moderatorsList = res.data.moderators;
      //   this.groupList = res.data.groups;
      //   this.groupUsedList = res.data.groupUseds;
      //   this.onClickCancel();
      //   this.$emit('info', '削除しました。');
      // } else {
      //   this.$emit('info', '削除できませんでした。');
      // }
      // }
    },
    // 部署削除処理
    async onClickDeleteDepartment() {
      // 子部署がいたら削除させない
      if (this.departments.some(v => v.parentID === this.selectDepartment.departmentID)) {
        this.$emit('info', '配下の部署があるため削除できません。');
        return;
      }
      // メンバーがいたら削除させない
      // ※メンバーがいる状態で削除許可するには、"未所属"部署が必ず存在していなければならない。
      //   "未所属"部署を存在させておく実装が困難なため一旦この入力チェックを入れることで対応
      if (this.selectDepartmentUsers.length) {
        this.$emit('info', '部署に対象ユーザーがいるため削除できません。');
        return;
      }

      const api = new API();
      const res = await api.delete<models.VUsers>('users/department/delete', {
        deleteID: this.selectedDepartmentID,
      });
      this.processAfterUpdate(res, '削除できませんでした。');
      this.isDefault = true;
      if (this.usersList.length > 0) {
        this.selectedUserID = this.usersList[0].userID;
      }
      this.backToSelectedUser(res);
      // if (res.result) {
      //   this.usersList = res.data.users;
      //   this.devicesList = res.data.devices;
      //   this.moderatorsList = res.data.moderators;
      //   this.groupList = res.data.groups;
      //   this.groupUsedList = res.data.groupUseds;
      //   this.onClickCancel();
      //   this.$emit('info', '削除しました。');
      // } else {
      //   this.$emit('info', '削除できませんでした。');
      // }
    },
    // 編集時処理 デバイス関連付け用サイドモーダル表示
    onClickAddDevice() {
      this.sideTitle = 'コンピュータを選択する';
      this.sideModal = SIDE.DEVICE;
    },
    // 編集時処理 管理者関連付け用サイドモーダル表示
    onClickAddModerator() {
      this.sideTitle = '管理者を選択する';
      this.sideModal = SIDE.MODERATOR;
    },
    // 編集時処理 グループ関連付け用サイドモーダル表示
    onClickAddGroup() {
      this.sideTitle = 'グループを選択する';
      this.sideModal = SIDE.GROUP;
    },
    // 編集時サイドモーダル追加時処理 サイドモーダル選択項目を編集項目に追加
    onClickAddSide(list: number[]) {
      // console.log(list);
      if (this.sideModal === SIDE.DEVICE) {
        // デバイスリストより選択された項目を追加
        this.editUserDevicesList = this.editUserDevicesList.concat(
          this.devicesList.filter((v: models.IDevice) => v.userID === 0 && list.includes(v.deviceID)),
        );
        // console.log(this.editUserDevicesList);
      } else {
        // ID追加
        this.editUserModeratorsList = this.editUserModeratorsList.concat(
          list.map(
            (v: number) =>
              ({
                generalID: this.editUser.userID,
                manageID: v,
              } as models.IModerator),
          ),
        );
      }
      this.onClickCloseSideModal();
    },
    // 編集時グループ追加時処理 グループ選択項目を編集項目に追加
    async onClickEditGroup(value: { groupList: models.IGroup[]; groupUsedList: models.IGroupUsed[] }) {
      this.editUserGroupList = value.groupList;
      this.editUserGroupUsedList = this.editUserGroupUsedList
        .filter(v => v.userID !== this.selectUser.userID)
        .concat(value.groupUsedList);
      // console.log('this editUserGroupUsedList', this.editUserGroupUsedList);
      this.onClickCloseSideModal();
    },
    // デバイス関連付け削除処理
    onClickDeleteEditDevice(value: number) {
      this.editUserDevicesList = this.editUserDevicesList.filter((v: models.IDevice) => v.deviceID !== value);
      this.onClickCloseSideModal();
    },
    // 編集時処理 管理者関連付け削除処理
    onClickDeleteEditModerator(value: number) {
      this.editUserModeratorsList = this.editUserModeratorsList.filter((v: models.IModerator) => v.manageID !== value);
      this.onClickCloseSideModal();
    },
    // サイドモーダルを閉じる処理
    onClickCloseSideModal() {
      this.sideModal = '';
    },
    // ユーザの権限を追加
    getUserStringRole(role: number): string {
      return NOCArray.getOptionsText(NOCArray.ROLE, role);
    },
    // 関連付けデータの情報取得
    // getModeratorUser(moderator: models.IModerator) {
    getModeratorUser(manageID: number) {
      // IDepartmentModeratorも使用できるように引数変更

      const targetUser = this.usersList.filter((v: models.IUser) => v.userID === manageID);
      return { name: targetUser[0].name, mail: targetUser[0].mail };
    },
    getWorkManage(workmanageID: number) {
      const targetWork = this.workmanages.filter(v => v.workmanageID === workmanageID);
      return { name: targetWork[0].name, id: targetWork[0].workmanageID };
    },
    setOptionsRole(role: number): IOption[] {
      // 値コピー
      const options = JSON.parse(JSON.stringify(NOCArray.ROLE));
      // 選択肢として不要なデータを削除
      options.shift();
      if (role === 1) {
        options.shift();
        options.shift();
      } else {
        options.pop();
      }
      return options;
    },
    onAddModal() {
      this.addModalShowFlag = !this.addModalShowFlag;
    },
    onCloseModal() {
      this.addModalShowFlag = false;
    },
    onPushPath(path: string) {
      this.$router.push(path, () => {});
      this.$emit('pushPath', path);
      this.onCloseModal();
    },
    onAddModalSp() {
      this.addSpModalShowFlag = true;
    },
    onClickSpCloseModal() {
      this.addSpModalShowFlag = false;
    },
    // 編集中のデータがあります ユーザー基本情報
    formUserBaseDataChange() {
      let editUserBaseDataChangeFlg = false;
      // 編集ボタン押下時のユーザー基本情報と比較
      if (
        Number(this.editUser.departmentID) === Number(this.compEditUser.departmentID) &&
        Number(this.editUser.jobID) === Number(this.compEditUser.jobID) &&
        this.editUserGroupUsedList.length === this.compEditUserGroupUsedList.length &&
        Number(this.editUser.workstyleID) === Number(this.compEditUser.workstyleID) &&
        Boolean(this.editUser.flextime) === Boolean(this.compEditUser.flextime) &&
        Number(this.editUser.role) === Number(this.compEditUser.role) &&
        this.editUserDevicesList.length === this.compEditUserDevicesList.length &&
        this.editUserModeratorsList.length === this.compEditUserModeratorsList.length &&
        this.editWorkmanages.length === this.compEditWorkmanages.length
      ) {
        editUserBaseDataChangeFlg = false;
      } else {
        editUserBaseDataChangeFlg = true;
      }

      if (editUserBaseDataChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    // 編集中のデータがあります プロフィール
    formUserProfileDataChange() {
      let editUserProfileDataChangeFlg = false;
      // 編集ボタン押下時のユーザープロフィールと比較
      // console.log(this.compEditUser)
      if (
        this.editUser.sei === this.compEditUser.sei &&
        this.editUser.mei === this.compEditUser.mei &&
        this.editUser.seiKana === this.compEditUser.seiKana &&
        this.editUser.meiKana === this.compEditUser.meiKana &&
        this.editUser.mail === this.compEditUser.mail &&
        Number(this.editUser.gender) === Number(this.compEditUser.gender) &&
        Number(this.editUser.birthday) === Number(this.compEditUser.birthday)
      ) {
        editUserProfileDataChangeFlg = false;
      } else {
        editUserProfileDataChangeFlg = true;
      }

      if (editUserProfileDataChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    // 編集中のデータがあります 部署基本情報
    formdDepartmentBaseDataChange() {
      let editDepartmentBaseDataChangeFlg = false;
      // 編集ボタン押下時の部署基本情報と比較
      if (
        this.editDepartment.name === this.compEditDepartment.name &&
        // && Number(this.editDepartment.workstyleID) === Number(this.compEditDepartment.workstyleID)
        // && Boolean(this.editDepartment.flextime) === Boolean(this.compEditDepartment.flextime)
        Number(this.editDepartment.parentID) === Number(this.compEditDepartment.parentID) &&
        this.editDepartmentModeratorsList.length === this.compEditDepartmentModeratorsList.length &&
        this.editWorkmanages.length === this.compEditWorkmanages.length
      ) {
        editDepartmentBaseDataChangeFlg = false;
      } else {
        editDepartmentBaseDataChangeFlg = true;
      }

      if (editDepartmentBaseDataChangeFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    // 編集中のデータがあります 部署の対象ユーザー
    formDepartmentUserDataChange() {
      let editUsersCheckFlg = false;
      let userItemCurrentDepFlg = false;
      // ユーザーのチェックボタンが押されているかどうか
      for (let i = 0; i < this.editUsers.length; i++) {
        if (Boolean(this.editUsers[i].checked) === false) {
          editUsersCheckFlg = false;
        } else {
          editUsersCheckFlg = true;
          break;
        }
      }
      // ユーザーの移動がされているか
      if (this.userItemCurrentDep.length === this.compUserItemCurrentDep.length) {
        for (let i = 0; i < this.userItemCurrentDep.length; i++) {
          if (this.userItemCurrentDep[i].userID === this.compUserItemCurrentDep[i].userID) {
            userItemCurrentDepFlg = false;
          } else {
            userItemCurrentDepFlg = true;
            break;
          }
        }
      } else {
        userItemCurrentDepFlg = true;
      }

      if (editUsersCheckFlg || userItemCurrentDepFlg) {
        // 編集ボタン押下後と差異があれば、編集中データのモーダルを表示する
        this.formDataChangeFlgModal = true;
      } else {
        this.formDataChangeFlgModal = false;
        this.selectBackMenu();
      }
    },
    selectBackMenu() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.SELECT;
      this.isDefault = true;
    },
    selectBack() {
      // console.log(this.selectedUserID);
      window.scrollTo(0, 0);
      if (this.mode === NOC.SETTING.MODE.SELECT || this.mode === NOC.SETTING.MODE.NORMAL_DEPARTMENT) {
        this.isDefault = true;
      } else if (this.selectedUserID > 0) {
        this.mode = NOC.SETTING.MODE.SELECT;
      } else if (this.selectedDepartmentID > 0) {
        this.mode = NOC.SETTING.MODE.NORMAL_DEPARTMENT;
      } else {
        this.mode = NOC.SETTING.MODE.NORMAL;
      }
      // this.isDefault = true;
    },
    selectBackToNewUser() {
      this.mode = NOC.SETTING.MODE.NEW;
      this.editProfile[4].required = false;
    },
    selectBackToNewDep() {
      this.mode = NOC.SETTING.MODE.NEW_DEPARTMENT;
    },
    // ユーザーを追加の初期表示
    addUser() {
      this.onClickCancel(); // 直前の編集内容をクリア
      this.editProfile[4].required = false;
      this.addModalShowFlag = false;
      // this.selectUser = new models.CUser();
      this.editUser = new models.CUser();
      this.editUserDevicesList = [] as models.IDevice[];
      this.editUserModeratorsList = [] as models.IModerator[];
      this.editUserGroupList = this.groupList;
      this.editWorkmanages = [] as modelsWorkManage.IWorkManage[];
      // this.editUserGroupUsedList = this.groupUsedList;
      this.editUserGroupUsedList = [];
      this.editItems[0].options = this.OPTION_DEPARTMENT_LIST;
      this.editItems[2].options = this.OPTION_GROUP_LIST;
      this.editItems[5].options = this.setOptionsRole(0);
      this.editItems[7].options = this.OPTION_DEVICE_LIST;
      this.editItems[8].options = this.OPTION_MODERATORS_LIST;
      this.editItems[9].options = this.OPTION_WORK_MG_LIST;
      this.clearFilter();
      // 編集ボタン押下時のデータを退避
      this.compEditUser = new models.CUser();
      this.compEditUserGroupList = JSON.parse(JSON.stringify(this.groupList));
      this.compEditUserDevicesList = [] as models.IDevice[];
      this.compEditUserModeratorsList = [] as models.IModerator[];
      this.mode = NOC.SETTING.MODE.NEW;
    },
    // ユーザーを追加
    addUserNext() {
      // validation
      if (validation.checkValues(this.editUser, this.editProfile)) {
        return false;
      }
      this.mode = NOC.SETTING.MODE.NEW_NEXT;
    },
    // 部署を追加の初期表示
    addDepartment() {
      this.onClickCancel(); // 直前の編集内容をクリア
      this.addModalShowFlag = false;
      this.mode = NOC.SETTING.MODE.NEW_DEPARTMENT;
      this.editDepartment = new models.CDepartment();
      // console.log(this.editDepartment)
      this.compEditDepartment = new models.CDepartment();
      // console.log(this.compEditDepartment)
      this.editDepartmentModeratorsList = [];
      this.compEditDepartmentModeratorsList = [];
      this.editWorkmanages = [];
      this.compEditWorkmanages = [];
      // this.editDepItems[3].options = this.OPTION_PARENT_DEPARTMENT_LIST;
      // this.editDepItems[4].options = this.OPTION_MODERATORS_LIST;
      this.editDepItems[1].options = this.OPTION_PARENT_DEPARTMENT_LIST();
      this.editDepItems[2].options = this.OPTION_MODERATORS_LIST;
      this.editDepItems[3].options = this.OPTION_WORK_MG_LIST;

      // 親部署として設定できない(親部署を持つ)部署
      const haveParentDep = [];
      for (const dep of this.departments) {
        // 親部署を持つ部署, 子部署を持つ部署を配列に追加
        if (dep.parentID) {
          haveParentDep.push(dep.departmentID);
        }
      }

      // 親部署に設定できない部署の添え字を格納
      const deleteIndex = [];
      for (let i = 0; i < this.editDepItems[1].options.length; i++) {
        let flag = false;
        for (const deleteDep of haveParentDep) {
          if (this.editDepItems[1].options[i].value === deleteDep) {
            flag = true;
          }
        }
        if (flag) {
          deleteIndex.push(i);
        }
      }
      // 親部署に設定できない部署、編集中の部署を選択肢から削除
      for (let i = deleteIndex.length - 1; i >= 0; i--) {
        this.editDepItems[1].options.splice(deleteIndex[i], 1);
      }
    },
    // 部署を追加
    addDepartmentNext() {
      this.addModalShowFlag = false;
      // 入力エラーが無ければ次へ
      // console.log(this.editDepartment, this.editDepItems);
      if (!validation.checkValues(this.editDepartment, this.editDepItems)) {
        this.mode = NOC.SETTING.MODE.NEW_DEPARTMENT_NEXT;
        this.setAllUserList(0);
      }
    },
    onClickAccordion(obj: models.IDepartmentInfo) {
      this.$set(obj, 'isClosed', !obj.isClosed);
    },
    getUsersInDepartment(departmentID: number): models.IUser[] {
      return this.usersList.filter(v => v.departmentID === departmentID);
    },
    getDepartmentsChildren(parentID: number): models.IDepartmentInfo[] {
      return this.departments.filter(v => parentID && v.parentID === parentID);
    },
    // グループ選択追加
    onInputGroup(selectList: number[]) {
      const newList: models.IGroupUsed[] = selectList.map(v => ({
        groupID: v,
        userID: this.editUser.userID,
      }));
      // console.log('on input group', selectList, this.editUserGroupUsedList, newList, this.editUser.userID);
      this.editUserGroupUsedList = this.editUserGroupUsedList.concat(newList);
    },
    // グループ選択除外
    onRemoveGroup(value: number) {
      this.editUserGroupUsedList = this.editUserGroupUsedList.filter(v => v.groupID !== value);
    },
    // デバイス選択追加
    onInputDevice(selectList: number[]) {
      const newList = this.devicesList.filter(v => selectList.indexOf(v.deviceID) > -1);
      this.editUserDevicesList = this.editUserDevicesList.concat(newList);
    },
    // デバイス選択除外
    onRemoveDevice(value: number) {
      this.editUserDevicesList = this.editUserDevicesList.filter(v => v.deviceID !== value);
    },
    // 労務管理者選択追加
    onInputManager(selectList: number[]) {
      const newList = selectList.map(v => ({
        manageID: v,
        generalID: this.editUser.userID,
      }));
      this.editUserModeratorsList = this.editUserModeratorsList.concat(newList);
    },
    // 労務管理者選択除外
    onRemoveManager(value: number) {
      this.editUserModeratorsList = this.editUserModeratorsList.filter(v => v.manageID !== value);
    },
    // 労務管理者選択追加（部署）
    onInputDepManager(selectList: number[]) {
      const newList = selectList.map(v => ({
        manageID: v,
        departmentID: this.editDepartment.departmentID,
      }));
      this.editDepartmentModeratorsList = this.editDepartmentModeratorsList.concat(newList);
    },
    // 労務管理者選択除外（部署）
    onRemoveDepManager(value: number) {
      this.editDepartmentModeratorsList = this.editDepartmentModeratorsList.filter(v => v.manageID !== value);
    },
    // 業務選択追加（部署）
    onInputWork(selectList: number[]) {
      if (this.editWorkmanages.length >= 50) {
        const msg = '51個以上の業務は紐づけられません。';
        this.$emit('info', msg);
        return;
      }
      const newList = selectList.map(
        v =>
          ({
            workmanageID: v,
            name: '',
            checked: true,
          } as modelsWorkManage.IWorkManage),
      );
      this.editWorkmanages = this.editWorkmanages.concat(newList);
    },
    // 業務選択除外（部署）
    onRemoveWork(value: number) {
      this.editWorkmanages = this.editWorkmanages.filter(v => v.workmanageID !== value);
    },
    // 部署のチェックボックス付きリスト部品
    // ユーザーリスト（チェックボックス付き）を設定
    async setAllUserList(departmentID: number) {
      const api = new API();
      const resUsers = await api.get<models.VDepartmentUsers>('users/department/users', {
        departmentID,
        isGetAll: true,
      });
      if (resUsers.result) {
        this.editUsers = resUsers.data.users;
        for (const user of this.editUsers) {
          user.checked = false;
        }
        this.optionsDepartment = [NOC.SELECT.ALL_DEPARTMENTS].concat(
          resUsers.data.departments.filter(v => v.value !== departmentID),
        );
      }
      // テーブル表示文字列(PC)
      this.userItem = JSON.parse(JSON.stringify(this.editUsers));
      this.userItemCurrentDep = JSON.parse(
        JSON.stringify(this.editUsers.filter(v => v.departmentChildID === this.selectedDepartmentID)),
      );
      this.userItemOtherDep = JSON.parse(
        JSON.stringify(this.editUsers.filter(v => v.departmentChildID !== this.selectedDepartmentID)),
      );
      // 編集ボタン押下時のデータを退避
      this.compUserItemSP = JSON.parse(JSON.stringify(this.userItemSP));
      this.compUserItemCurrentDep = JSON.parse(JSON.stringify(this.userItemCurrentDep));
      for (const item of this.userItem) {
        let user = `${item.sei} ${item.mei}`;
        if (item.mail) {
          user += ` (${item.mail})`;
        }
        item.user = user;
      }
      for (const item of this.userItemCurrentDep) {
        item.checked = false;
        item.user = `${item.sei} ${item.mei}`;
      }
      for (const item of this.userItemOtherDep) {
        item.user = `${item.sei} ${item.mei}`;
      }
      // テーブル表示文字列(SP)
      this.userItemSP = JSON.parse(JSON.stringify(this.editUsers));
      for (const item of this.userItemSP) {
        const user = `${item.sei} ${item.mei}`;
        item.user = user;
      }
    },
    // 絞り込むボタン押下時処理
    onClickFilter() {
      this.searchDepartment = this.inputedSearchDepartment;
      this.searchName = this.inputedSearchName;
      this.searchNameCurrentDep = this.inputedSearchName;
    },
    onClickFilterCurrentDep() {
      this.searchNameCurrentDep = this.inputedSearchNameCurrentDep;
    },
    onClickFilterOtherDep() {
      this.searchDepartment = this.inputedSearchDepartment;
      this.searchName = this.inputedSearchName;
    },
    filteringUser(row: any, filter: any) {
      // すべての部署以外は親部署・子部署のどちらかにヒットしたら表示
      const matchDepartment =
        !filter.departmentID ||
        row.departmentParentID === filter.departmentID ||
        row.departmentChildID === filter.departmentID;
      return matchDepartment && (!filter.userName || strFuzzyMatch(filter.userName, row.user));
    },
    clearFilter() {
      this.inputedSearchDepartment = 0;
      this.inputedSearchName = '';
      this.inputedSearchNameCurrentDep = '';
      this.searchDepartment = 0;
      this.searchName = '';
      this.searchNameCurrentDep = '';
    },
    onCheckUser(data: models.IDepartmentUsedUser, checked: boolean) {
      for (const user of this.editUsers) {
        if (user.userID === data.userID) {
          user.checked = checked;
          break;
        }
      }
    },
    onCheckAllUser(checked: boolean) {
      for (const user of this.editUsers) {
        user.checked = checked;
      }
    },
    onCheckAllCurrentUser(checked: boolean) {
      for (const user of this.editUsers) {
        for (const i of this.userItemCurrentDep) {
          if (user.userID === i.userID) {
            user.checked = checked;
          }
        }
      }
    },
    onCheckAllOtherUser(checked: boolean) {
      for (const user of this.editUsers) {
        for (const i of this.userItemOtherDep) {
          if (user.userID === i.userID) {
            user.checked = checked;
          }
        }
      }
    },
    // 部署メンバー編集のその他部署からの移動
    moveUserToCurrentDep() {
      const checkedUsers = this.editUsers.filter(v => v.checked);
      for (const user of checkedUsers) {
        const idx = this.userItemOtherDep.findIndex(v => v.userID === user.userID);
        if (idx > -1) {
          const item = this.userItemOtherDep[idx];
          item.checked = false;
          user.checked = false;
          user.departmentID = this.selectedDepartmentID; // 更新時に参照する部署ID
          this.userItemCurrentDep.push(item);
          this.userItemOtherDep.splice(idx, 1);
        }
      }
      // console.log(this.userItemCurrentDep,this.userItemOtherDep);
    },
    moveUserToOtherDep(depart: number) {
      const checkedUsers = this.editUsers.filter(v => v.checked);
      // const checkedUsersID = checkedUsers.map((v) => v.userID);
      for (const user of checkedUsers) {
        const idx = this.userItemCurrentDep.findIndex(v => v.userID === user.userID);
        if (idx > -1) {
          const item = this.userItemCurrentDep[idx];
          item.checked = false;
          user.checked = false;
          user.departmentID = depart; // 更新時に参照する部署ID
          const targetDep = this.alldepartments.find(v => v.departmentID === depart);
          if (targetDep) {
            // その他リストに表示する部署
            item.departmentChildID = depart;
            item.departmentChild = targetDep.name;
            if (targetDep.parentID) {
              const parentDep = this.alldepartments.find(v => v.departmentID === targetDep.parentID);
              item.departmentParent = parentDep ? parentDep.name : '';
            } else {
              item.departmentParent = '';
            }
          }
          this.userItemOtherDep.push(item);
          this.userItemCurrentDep.splice(idx, 1);
        }
      }
      // this.otheritem.push([this.alldepartments.filter((v) => v.departmentID === depart), checkedUsersID]);
    },
    // 部署の初期表示
    normalDepartment() {
      this.mode = NOC.SETTING.MODE.NORMAL_DEPARTMENT;
    },
    // 部署の基本情報の編集
    onClickEditBaseDepartment() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.EDIT_BASE_DEPARTMENT;
      this.editDepartment = JSON.parse(JSON.stringify(this.selectDepartment));

      // this.editDepItems[3].options = this.OPTION_PARENT_DEPARTMENT_LIST;
      // this.editDepItems[4].options = this.OPTION_MODERATORS_LIST;
      this.editDepItems[1].options = this.OPTION_PARENT_DEPARTMENT_LIST();
      this.editDepItems[2].options = this.OPTION_MODERATORS_LIST;
      this.editDepItems[3].options = this.OPTION_WORK_MG_LIST;
      this.editDepartmentModeratorsList = JSON.parse(JSON.stringify(this.selectDepartmentModeratorsList));
      // 部署に紐づく業務を設定
      this.editWorkmanages.forEach(v => this.onRemoveWork(v.workmanageID)); // 選択済みの業務の初期化
      this.onInputWork(this.selectDepartment.workmanageId); // 既に紐づいている業務を選択済みにする

      // 親部署として設定できない(親部署を持つ)部署, 子部署を持つ配列
      const haveParentDep = [];
      const haveChildDep = [];
      for (const dep of this.departments) {
        // 親部署を持つ部署, 子部署を持つ部署を配列に追加
        if (dep.parentID) {
          haveParentDep.push(dep.departmentID);
          for (const dep2 of this.departments) {
            if (dep2.departmentID === dep.parentID) {
              haveChildDep.push(dep2.departmentID);
            }
          }
        }
      }
      // 編集中の部署の名前を追加(編集中の部署を親部署に設定できないようにするため)
      haveParentDep.push(this.editDepartment.departmentID);

      // 子部署を持つかどうか
      let haveChildFlag = false;
      for (const dep of haveChildDep) {
        if (dep === this.editDepartment.departmentID) {
          haveChildFlag = true;
        }
      }

      if (haveChildFlag) {
        // 子部署を持つ場合、親部署の設定は不可
        this.editDepItems[1].options.splice(1, this.editDepItems[1].options.length - 1);
      } else {
        // 子部署を持たない部署を編集している場合
        // 親部署に設定できない部署の添え字を格納
        const deleteIndex = [];
        for (let i = 0; i < this.editDepItems[1].options.length; i++) {
          let flag = false;
          for (const deleteDep of haveParentDep) {
            if (this.editDepItems[1].options[i].value === deleteDep) {
              flag = true;
            }
          }
          if (flag) {
            deleteIndex.push(i);
          }
        }
        // 親部署に設定できない部署、編集中の部署を選択肢から削除
        for (let i = deleteIndex.length - 1; i >= 0; i--) {
          this.editDepItems[1].options.splice(deleteIndex[i], 1);
        }
      }

      // 編集ボタン押下時のデータを退避
      this.compEditDepartment = JSON.parse(JSON.stringify(this.selectDepartment));
      this.compEditDepartmentModeratorsList = JSON.parse(JSON.stringify(this.selectDepartmentModeratorsList));
      this.compEditWorkmanages = JSON.parse(JSON.stringify(this.editWorkmanages));
    },
    // 部署の対象ユーザーの編集
    onClickEdit() {
      window.scrollTo(0, 0);
      this.mode = NOC.SETTING.MODE.EDIT;
      this.editDepartment = JSON.parse(JSON.stringify(this.selectDepartment));
      this.clearFilter();
      this.setAllUserList(this.selectDepartment.departmentID);
    },
    // 部署の削除するクリック時
    deleteDepartment() {
      this.deleteDepartmentShowFlag = true;
    },
    /*
    closeModal() {
      this.deleteDepartmentShowFlag = false;
      this.deleteUserShowFlag = false;
    },
    // ユーザーの削除するクリック時
    deleteUserConfirm() {
      this.deleteUserShowFlag = true;
    },
    */
    // CSVインポートのモーダル
    async csvImportModal() {
      this.mode = NOC.SETTING.MODE.CSV_IMPORT;
      this.importStatus = 'init';
      this.addModalShowFlag = false;
      const api = new API();
      const res = await api.get<models.VInsertHistory>('users/csv/history');
      if (res.result) {
        this.historyList = res.data.insertHistories;
      }
    },
    onChangeInput(value: any, item: INewVariableInput) {
      validation.checkValue(value, item);
    },
    onClickClose() {
      this.$emit('close');
    },
    // CSVインポート ---------------------------------------
    // インポートエリアクリック時
    onChangeFile(event: any) {
      const files = event.target.files;
      this.importFile = files[0];
      // console.log('change', this.importFile);
    },
    // テンプレートダウンロード
    async downloadTemplate(key: string) {
      const api = new API();
      await api.post<any, any>('users/csv/template', { key });
    },
    // ファイル指定後のインポートボタンクリック時
    async onClickImport() {
      let error = '';
      // 1MBを超えていたらインポートしない
      if (this.importFile.size > 1048576) {
        // 1MB
        error = 'ファイルサイズが1MBを超えています。';
        this.importError = 'ファイルサイズが1MBを超えています。';
        return;
      }

      // encoding.jsを使用して任意の文字コードでテキスト読み込み
      // 読み込みが完了したらAPIを呼び出してインポート前確認を実行
      // https://catprogram.hatenablog.com/entry/2015/04/23/171157
      const reader = new FileReader();
      reader.onload = async e => {
        // 読み込み完了時の処理
        // console.log(e, reader.result);
        // 読み込んだ任意の文字コードのArrayBufferをUnicodeに変換
        const uint8View = new Uint8Array(reader.result as ArrayBuffer);
        const converted = Encoding.convert(uint8View, 'UNICODE');
        // 文字列に変換
        const csvText = Encoding.codeToString(converted);
        // console.log('csvText', csvText);
        // API通信（インポート前確認）
        const api = new API();
        const res = await api.post<any, modelsCsv.VConfirmData>('users/csv/file', { file: csvText });
        if (res.result) {
          this.importError = '';
          this.csvConfirmData = res.data;
          // エラー出力のため行ごとに持ち変える
          this.errorRows = Array(this.csvConfirmData.dataList.length);
          for (const err of this.csvConfirmData.errorList) {
            if (!this.errorRows[err.rowNum - 1]) {
              this.errorRows[err.rowNum - 1] = {};
            }
            this.errorRows[err.rowNum - 1][err.column] = err.message;
          }
        } else {
          this.importError = 'エラーが発生しました。';
        }
        this.importStatus = 'confirm';
      };

      // ArrayBufferとして読み込み開始（この処理が終わると上の処理が実行される）
      reader.readAsArrayBuffer(this.importFile);
    },
    // インポート実行
    async doImport() {
      // API通信
      this.csvConfirmData.filename = this.importFile.name;
      const api = new API();
      this.isProcessing = true;
      const res = await api.post<modelsCsv.VConfirmData, models.VUsers>('users/csv/regist', this.csvConfirmData);
      this.processAfterUpdate(res, '', () => {});
      if (res.result) {
        const histories = res.data.insertHistories;
        if (histories[0].success) {
          this.importStatus = 'complete';
        } else {
          this.importStatus = 'complete_error';
        }
      } else {
        this.importStatus = 'complete_error';
      }
      // this.importStatus = res.result ? 'complete' : 'complete_error';
      this.isProcessing = false;

      // 重複チェックでエラーとなったデータ件数をカウント
      for (let i = 0; i < this.csvConfirmData.errorList.length; i++) {
        if (this.csvConfirmData.errorList[i].column === 'all') {
          this.duplicateCount++;
        }
      }
    },
    // インポート実行後のとじるボタンクリック時
    resetImport() {
      this.errorRows = [];
      this.importFile = null;
      this.importStatus = 'init';
      this.duplicateCount = 0;
    },
    resetError() {
      this.importFile = null;
      this.importError = '';
    },
  },
});
